import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  label = '5 out of 5 stars'
}: {
  label?: string;
}) {
  return <div className="flex items-center gap-0.5" role="img" aria-label={label} data-id="element-199" data-mp="3gpcpg81hzd3i">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-200" data-mp="3ks97nxn4l76x" data-mpi={i} />)}
    </div>;
}